import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Paper,
  FormControlLabel,
  Switch,
} from "@mui/material";
import { Row, Col, Form } from "react-bootstrap";
import makeStyles from "@mui/styles/makeStyles";
import AADService from "../funcionesAuth.js";
import VistaGraficos from "./VistaGraficos.js";
import GraficaSuciaLimpia from "./GraficaSuciaLimpia.js";
// -------- Helpers --------
function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) return -1;
  if (b[orderBy] > a[orderBy]) return 1;
  return 0;
}
function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  { id: "idactivo", label: "idAplicacion" },
  { id: "nombre", label: "Nombre Aplicacion" },
  { id: "idero", label: "idEvaluacion" },
  //{ id: "controles_implementados", label: "Controles Implementados" },
  { id: "caracteristica_seguridad", label: "Característica de Seguridad" },
  { id: "efectividad_actual", label: "Efectividad" },
  { id: "aporte_control_introducir", label: "Aporte" },
  { id: "aporte_control_p50_introducir", label: "Protección Control P50" },
  { id: "aporte_control_p95_introducir", label: "Protección Control P95" },
  { id: "aporte_control_p99_introducir", label: "Protección Control P99" },
];

function EnhancedTableHead({ order, orderBy, onRequestSort }) {
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => {
          const isActive = orderBy === headCell.id;
          return (
            <TableCell
              key={headCell.id}
              sortDirection={isActive ? order : false}
              style={{
                backgroundColor: "#2c2a29",
                color: isActive ? "#bdbdbd" : "#fff", // gris si activo, blanco si no
              }}
            >
              <TableSortLabel
                active={isActive}
                direction={isActive ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
                style={{
                  color: isActive ? "#bdbdbd" : "#fff", // gris si activo, blanco si no
                }}
              >
                {headCell.label}
              </TableSortLabel>
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
};

const useStyles = makeStyles(() => ({
  container: { maxHeight: "55vh", minHeight: "55vh" },
  root: { width: "100%" },
  paper: { width: "100%" },
  table: { minWidth: 750 },
}));

// -------- Componente principal --------
function ControlesProtegidos({ onResumenChange }) {
  const AzureADService = new AADService();
  const token = AzureADService.getToken();
  const classes = useStyles();
  const [rows, setRows] = useState([]);
  const [resumen, setResumen] = useState({});
  const [cantidadApps, setCantidadApps] = useState(0);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("nombre");
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [queryText, setQueryText] = useState("");
  const [lastModified, setLastModified] = useState("");

  // -------- Fetch automático --------
  useEffect(() => {
    const fetchDataTabla = async () => {
      try {
        const result = await fetch(
          `${
            process.env.REACT_APP_API_URL
          }maestro/componentexcontrol/${localStorage.getItem(
            "idimplementador"
          )}/${localStorage.getItem("idcompania")}/`,
          {
            method: "GET",
            headers: { Accept: "application/json",
              Authorization: "Bearer " + token,
             },
          }
        );

        const text = await result.text();
        console.log("Respuesta cruda del servidor:", text);

        let data;
        try {
          data = JSON.parse(text);
        } catch (error) {
          console.error("Error al parsear JSON:", error);
          return;
        }

        console.log("Data fetched componentexcontrol resumen:", data.resumen);
        setRows(data.detalle || []);
        setResumen(data.resumen || {});
        setCantidadApps(data.cantidad_apps || 0);
        setLastModified(
          data.last_modified
            ? new Date(data.last_modified).toISOString().split("T")[0]
            : ""
        );

        if (onResumenChange) {
          onResumenChange(data.resumen || {});
        }

      } catch (error) {
        console.error("Error cargando datos:", error);
      }
    };

    fetchDataTabla();
  }, []);

  const formatWithThousands = (value) => {
    if (value == null || isNaN(value)) return "0.00";
    return value.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };
  // -------- Handlers --------
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const filteredData = rows.filter((row) =>
    row.nombre?.toLowerCase().includes(queryText.toLowerCase())
  );

  const emptyRows =
    rowsPerPage -
    Math.min(rowsPerPage, filteredData.length - page * rowsPerPage);

  // -------- Render --------
  return (
    <div className={classes.root}>
      {/* Input de cantidad de aplicaciones */}
      <Row style={{ margin: "1% 0" }}>
        <Col sm={6} xs={12}>
          <h5 style={{ marginLeft: "16px", marginTop: "16px" }}>
            Número de aplicaciones protegidas : {cantidadApps}
          </h5>
        </Col>
        <Col sm={6} xs={12}>
          <h5 style={{ marginLeft: "16px", marginTop: "0px" }}>
            Última actualización de datos : {lastModified}
          </h5>
        </Col>
      </Row>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-start",
          justifyContent: "center",
          gap: "32px",
        }}
      >
        <Col style={{ flex: 1 }}>
          <VistaGraficos resumen={resumen} detalle={rows} />
        </Col>
      </div>
      <Row>
        <h2 style={{ marginLeft: "16px", marginTop: "16px" }}>
          Resumen de protección e impacto de las vulnerabilidades en la
          protección
        </h2>
      </Row>
      <br />
      {/* Tabla resumen */}
      <Paper className={classes.paper} style={{ marginBottom: "16px" }}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell
                  style={{ backgroundColor: "#2c2a29", color: "#fff" }}
                >
                  Característica
                </TableCell>
                <TableCell
                  style={{ backgroundColor: "#2c2a29", color: "#fff" }}
                >
                  Protección Control P50(Con Vulnerabilidades)
                </TableCell>
                <TableCell
                  style={{ backgroundColor: "#2c2a29", color: "#fff" }}
                >
                  Protección Control P95(Con Vulnerabilidades)
                </TableCell>
                <TableCell
                  style={{ backgroundColor: "#2c2a29", color: "#fff" }}
                >
                  Protección Control P99(Con Vulnerabilidades)
                </TableCell>
                <TableCell
                  style={{ backgroundColor: "#2c2a29", color: "#fff" }}
                >
                  Protección Control P50(Sin Vulnerabilidades)
                </TableCell>
                <TableCell
                  style={{ backgroundColor: "#2c2a29", color: "#fff" }}
                >
                  Protección Control P95(Sin Vulnerabilidades)
                </TableCell>
                <TableCell
                  style={{ backgroundColor: "#2c2a29", color: "#fff" }}
                >
                  Protección Control P99(Sin Vulnerabilidades)
                </TableCell>
                <TableCell
                  style={{ backgroundColor: "#2c2a29", color: "#fff" }}
                >
                  Diferencia P50
                </TableCell>
                <TableCell
                  style={{ backgroundColor: "#2c2a29", color: "#fff" }}
                >
                  Diferencia P95
                </TableCell>
                <TableCell
                  style={{ backgroundColor: "#2c2a29", color: "#fff" }}
                >
                  Diferencia P99
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {["Confidencialidad", "Integridad", "Disponibilidad"].map(
                (car) => (
                  <TableRow key={car}>
                    <TableCell>{car}</TableCell>
                    <TableCell>
                      {formatWithThousands(
                        resumen[car]?.aporte_control_p50_introducir ?? 0
                      )}
                    </TableCell>
                    <TableCell>
                      {formatWithThousands(
                        resumen[car]?.aporte_control_p95_introducir ?? 0
                      )}
                    </TableCell>
                    <TableCell>
                      {formatWithThousands(
                        resumen[car]?.aporte_control_p99_introducir ?? 0
                      )}
                    </TableCell>
                    <TableCell>
                      {formatWithThousands(
                        resumen[car]?.aporte_control_p50_total ?? 0
                      )}
                    </TableCell>
                    <TableCell>
                      {formatWithThousands(
                        resumen[car]?.aporte_control_p95_total ?? 0
                      )}
                    </TableCell>
                    <TableCell>
                      {formatWithThousands(
                        resumen[car]?.aporte_control_p99_total ?? 0
                      )}
                    </TableCell>
                    <TableCell>
                      {formatWithThousands(resumen[car]?.diferencia_p50 ?? 0)}
                    </TableCell>
                    <TableCell>
                      {formatWithThousands(resumen[car]?.diferencia_p95 ?? 0)}
                    </TableCell>
                    <TableCell>
                      {formatWithThousands(resumen[car]?.diferencia_p99 ?? 0)}
                    </TableCell>
                  </TableRow>
                )
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
      <Row>
        <h2 style={{ marginLeft: "16px", marginTop: "16px" }}>
          Impacto de las vulnerabilidades presentes en en el control
        </h2>
      </Row>
      <Row>
        <Col sm={12} xs={12}>
          <GraficaSuciaLimpia resumen={resumen} />
        </Col>
      </Row>
      <Row>
        <h2 style={{ marginLeft: "16px", marginTop: "16px" }}>
          Detalle de aplicaciones protegidas por el control
        </h2>
      </Row>
      {/* Filtro y tabla principal */}
      <Row style={{ margin: "1% 0" }}>
        <Col sm={3} xs={12}>
          <Form className="buscar">
            <Form.Control
              type="text"
              placeholder="Buscar"
              onChange={(e) => setQueryText(e.target.value)}
            />
          </Form>
        </Col>
      </Row>

      <Paper className={classes.paper}>
        <TableContainer className={classes.container}>
          <Table stickyHeader className={classes.table}>
            <EnhancedTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
            />
            <TableBody>
              {stableSort(filteredData, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <TableRow hover key={index}>
                    <TableCell>{row.idactivo}</TableCell>
                    <TableCell>{row.nombre}</TableCell>
                    <TableCell>{row.idero}</TableCell>
                    {/*<TableCell>{row.controles_implementados}</TableCell>*/}
                    <TableCell>{row.caracteristica_seguridad}</TableCell>
                    <TableCell>{row.efectividad_actual !== "" && row.efectividad_actual !== null
                        ? `${(Number(row.efectividad_actual) * 100).toFixed(2)}%`
                        : "0%"}</TableCell>
                    <TableCell>
                      {row.aporte_control_introducir !== "" && row.aporte_control_introducir !== null
                        ? `${(Number(row.aporte_control_introducir) * 100).toFixed(2)}%`
                        : "0%"}
                    </TableCell>
                    <TableCell>
                      {row.aporte_control_p50_introducir !== "" &&
                      row.aporte_control_p50_introducir !== null
                        ? formatWithThousands(Number(row.aporte_control_p50_introducir))
                        : "0,00"}
                    </TableCell>
                    <TableCell>
                      {row.aporte_control_p95_introducir !== "" &&
                      row.aporte_control_p95_introducir !== null
                        ? formatWithThousands(Number(row.aporte_control_p95_introducir))
                        : "0,00"}
                    </TableCell>
                    <TableCell>
                      {row.aporte_control_p99_introducir !== "" &&
                      row.aporte_control_p99_introducir !== null
                        ? formatWithThousands(Number(row.aporte_control_p99_introducir))
                        : "0,00"}
                    </TableCell>
                  </TableRow>
                ))}
              {emptyRows > 0 && (
                <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
                  <TableCell colSpan={11} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <Row style={{ margin: "8px" }}>
          <Col sm={4} xs={4}>
            <FormControlLabel
              control={
                <Switch
                  checked={dense}
                  onChange={(e) => setDense(e.target.checked)}
                />
              }
              label="Vista compacta"
            />
          </Col>
          <Col xs={8}>
            <TablePagination
              rowsPerPageOptions={[10, 20, 30]}
              component="div"
              count={filteredData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              labelRowsPerPage="Filas por página"
            />
          </Col>
        </Row>
      </Paper>
    </div>
  );
}

export default ControlesProtegidos;
